module.exports = __webpack_public_path__ + "media/bell.28e0125c.wav";